import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPrivacyPolicy, updatePrivacyPolicyThunk } from "../../slices/staticPages/thunk";
import { resetPrivacyPolicyFlag } from "../../slices/staticPages/reducer";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";

function PrivacyPolicy() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const privacyPolicy = state?.StaticPages?.privacyPolicy || {};
  const [editorData, setEditorData] = useState("");

  useEffect(() => {
    dispatch(fetchPrivacyPolicy());
  }, [dispatch]);

  useEffect(() => {
    if (privacyPolicy?.data?.htmlContent) {
      setEditorData(privacyPolicy.data.htmlContent);
    }
  }, [privacyPolicy?.data?.htmlContent]);

  const handleSave = () => {
    dispatch(updatePrivacyPolicyThunk({ htmlContent: editorData }));
  };

  useEffect(() => {
    if (privacyPolicy?.success) {
      const timer = setTimeout(() => dispatch(resetPrivacyPolicyFlag()), 3000);
      return () => clearTimeout(timer);
    }
  }, [privacyPolicy?.success, dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Privacy Policy" pageTitle="Privacy Policy" />
        </Container>
      </div>

      <div className="static-page"
        style={{
          marginBottom: "55px",
          background: "white",
          padding: "1rem",
        }}
      >
        <label className="form-label fw-bold">HTML Content</label>

        {/* CKEditor */}
        <div className="border p-2">
          <CKEditor
            editor={ClassicEditor}
            data={editorData || ""}
            onChange={(event, editor) => {
              try {
                setEditorData(editor.getData());
              } catch (e) {
                console.error("Editor error:", e);
              }
            }}
          />
        </div>

        <button
          className="btn btn-primary mt-3"
          disabled={privacyPolicy?.loading}
          onClick={handleSave}
        >
          {privacyPolicy?.loading ? "Saving..." : "Save"}
        </button>

        {privacyPolicy?.success && (
          <div className="alert alert-success mt-3">{privacyPolicy.success}</div>
        )}
        {privacyPolicy?.error && (
          <div className="alert alert-danger mt-3">{privacyPolicy.error}</div>
        )}

        {/* Preview */}
        <h5 className="form-label fw-bold mt-4">Preview</h5>
        <div
          style={{
            border: "1px solid #ccc",
            padding: "15px",
            borderRadius: "4px",
            minHeight: "100px",
          }}
          dangerouslySetInnerHTML={{ __html: editorData || "" }}
        />
      </div>
    </React.Fragment>
  );
}

export default PrivacyPolicy;
